import { LoadableBackground } from '@confluence/loadable';

export const CopySpacePermissionsForLegacyNewSpace = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopySpacePermissionsForLegacyNewSpace" */ '../src/CopySpacePermissionsForLegacyNewSpace'
			)
		).CopySpacePermissionsForLegacyNewSpace,
	name: 'CopySpacePermissionsForLegacyNewSpace',
});
